"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("./base");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var SharedBlockContainer =
/*#__PURE__*/
function (_BlockContainer) {
  babelHelpers.inherits(SharedBlockContainer, _BlockContainer);

  function SharedBlockContainer() {
    babelHelpers.classCallCheck(this, SharedBlockContainer);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(SharedBlockContainer).apply(this, arguments));
  }

  return SharedBlockContainer;
}(_base.BlockContainer);

exports.default = SharedBlockContainer;